<template>
  <div>
    <RevLoadingScreen
      v-if="status === 'pending'"
      class="mb-7"
      :text="i18n(translations.loadingScreen)"
    />

    <ProductAttributesTable
      v-if="status === 'success' && data"
      class="mb-6"
      :product-details="data"
      :without-header
    />

    <RevInfoBlock
      v-if="status === 'error' && error"
      class="mb-6"
      :content="error.message"
      :icon="IconAlert"
      :title="i18n(translations.errorTitle)"
      variant="danger"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import { catalogAccessAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { IconAlert } from '@ds/icons/IconAlert'

import ProductAttributesTable from '../ProductAttributesTable/ProductAttributesTable.vue'

import translations from './ProductCardDetail.translations'

const i18n = useI18n()

const props = defineProps<{ productId: string; withoutHeader: boolean }>()

const { data, status, error, refresh } = useHttpFetch(
  catalogAccessAPI.getSellerProductDetails,
  {
    pathParams: { productId: props.productId },
    queryParams: {
      withCategoryAttributes: true,
    },
    server: false,
    immediate: false,
  },
)

onMounted(() => {
  refresh()
})
</script>
